import { getIndexUrl } from '../../../app/utils/siteUrls';

import { getCurrentLang } from 'react-redux-app/lib/modules/i18n/selectors';
import { getIsActive } from '../../selectors';


// Note: auth is required
export default ({ getState, dispatch }) => (
  function notActiveRequiredHandler(nextState, successCallback, errorCallback) {
    const isUserActive = getIsActive(getState());
    if (isUserActive) {
      errorCallback(getIndexUrl(getCurrentLang(getState())));
    } else {
      successCallback();
    }
  }
);
